/**************** WEBAPP CONSTANT (start) **************************/ // General Page Section
export const HOME_PAGE = "/";
// account / login / signup /
export const LOGIN_PAGE = "/member/login";
export const LOGIN_EXIST_KAKAO = "/member/login/exist-kakao-account";
export const LOGIN_EXIST_PHONE = "/member/login/exist-account";
export const LOGIN_WITH_PHONE_PAGE = "/member/login/phone";
export const LOGIN_RESET_PASSWORD_PAGE = "/member/login/reset-password";
export const REGISTRATION_PAGE = "/member/signup";
export const REGISTRATION_WITH_PHONE_PAGE = "/member/signup/phone";
export const FORGOT_USERNAME_PAGE = "/forgot-username";
export const FORGOT_PASSWORD_PAGE = "/forgot-password";
export const FORGOT_PASSWORD_NEW_PAGE = "/member/forgot-password/new";
export const SIGNUP_WITH_PHONE = "/member/signup/form";
export const SIGNUP_AFTER_USER_PROFILE = "/member/signup/profile";
export const SIGNUP_COMPLETE = "/member/signup/complete";
// 전역 프로필 가드(useProfileGuard)가 동작하지 않아야 하는 경로 prefix.
// - /member: 인증/가입/프로필 플로우 자체(목적지) — 가드 시 무한루프
// - /shop/checkout: 결제 진행·완료 화면 — 거래 중이라 가로채면 빌링 콜백(authKey)이 유실된다
// - /viewer: 뷰어, /admin·/publisher: 별도 로그인 도메인, /solvook-app: 웹뷰, /receipt: 영수증, /expert: 외부 리다이렉트
export const GUARD_EXEMPT_PREFIXES = [
    "/member",
    // 빌링 등록창은 successUrl로 전체 페이지를 되돌린다. 이때 SSR getMe가 다시 돌아 store의
    // hasSignupBenefitLog가 BE 값(false)으로 리셋되므로, 면제하지 않으면 가드가 복귀 URL을
    // 가로채 authKey가 유실된다. 하위 경로의 결제 완료 화면(complete/subscription-complete)도 함께 면제된다.
    "/shop/checkout",
    "/viewer",
    "/admin",
    "/publisher",
    "/solvook-app",
    "/receipt",
    "/expert"
];
// company
// guides-for-copyright-holder
export const MOBILE_CATEGORY_PAGE = "/categories";
export const INTRODUCE_PAGE = "/introduce";
export const UCI_PAGE = "/protection/uci";
export const RNUMBER_PAGE = "/protection/rNumber";
// todo: 저작권자 영어로 뭐라고 할지?
export const GUIDES_PAGE = "/guides";
export const B2B_INDEX_PAGE = "/b2b";
export const B2B_WEBFLOW_PAGE = "https://help.solvook.com/b2b";
export const HELP_INDEX_PAGE = "/help";
export const HELP_FAQS_INDEX_PAGE = "/help/faqs";
export const HELP_NOTICES_INDEX_PAGE = "/help/notices";
// Terms
export const TERMS_OF_USE_PAGE = "https://solvookguide.oopy.io/policies/20260917";
export const PRIVACY_PAGE = "https://solvookguide.oopy.io/policies/privacy";
export const TERMS_OF_REFUND_PAGE = "https://solvookguide.oopy.io/policies/refund/20260917";
export const TERMS_OF_LICENSE_PAGE = "/policies/license";
// protection
export const COPYRIGHT_PROTECTION_INDEX_PAGE = "/protection";
// category
export const CATEGORY_PAGE = "/categories";
//Fixme : 과거 어딘가에서 사용중이어서 삭제하지 않음
// 삭제 예정 25.05.23
export const CATEGORY_TEXTBOOK_PAGE = "/category/textbook";
export const CATEGORY_WORKBOOK_PAGE = "/category/workbook";
export const CATEGORY_HANDOUT_PAGE = "/category/handout";
export const CATEGORY_WORK_PAGE = "/category/work";
// products
// resources
export const PRODUCTS_PAGE = "/products";
//search
export const PRODUCT_SEARCH_PAGE = "/search";
//@todo 임시 url
// 삭제 예정 25.05.23
export const PRODUCTS_TEXTBOOK_PAGE = "/products?category=textbook";
export const PRODUCTS_WORKBOOK_PAGE = "/products?category=workbook";
export const PRODUCTS_HANDOUT_PAGE = "/products?category=handout";
// export const PRODUCTS_TEXTBOOK_PAGE = '/products/textbook'
// export const PRODUCTS_WORKBOOK_PAGE = '/products/workbook'
// export const PRODUCTS_HANDOUT_PAGE = '/products/handout'
export const PRODUCTS_DETAIL_PAGE = "/products/";
// shop
export const TOSS_VARIANT_DEFAULT = "DEFAULT";
export const SHOP_CART_PAGE = "/shop/cart";
export const DELIVERY_CART_PAGE = "/shop/cart?currentCart=delivery";
export const SHOP_CHECKOUT_PAGE = "/shop/checkout";
export const SHOP_CHECKOUT_COMPLETE_PAGE = "/shop/checkout/complete";
// 월구독 가입 완료. 주문 조회(orderId) 기반인 complete 와 데이터 출처가 달라 별도 라우트로 둔다
export const SHOP_CHECKOUT_SUBSCRIPTION_COMPLETE_PAGE = "/shop/checkout/subscription-complete";
export const SHOP_CHECKOUT_UPGRADE_PAGE = "/shop/checkout?upgrade";
export const NEW_PRODUCTS_PAGE = "/search" //검색
;
export const B2B_LANDING_PAGE = "/b2b";
export const LIBRARIES_INDEX_PAGE = "/libraries" // 라이브러리
;
export const CLASS_INDEX_PAGE = "/class";
export const MYPAGE_PAGE = "/mypage" // 마이페이지 메인
;
// mySolvook Tab
export const MYPAGE_ORDERS_INDEX_PAGE = "/mypage/orders" // 결제관리
;
export const MYPAGE_ACCOUNTS_INDEX_PAGE = "/mypage/accounts" // 계정관리
;
export const MYPAGE_DEVICE_INDEX_PAGE = "/mypage/devices";
export const MYPAGE_LIBRARY_INDEX_PAGE = "/mypage/libraries";
export const CASH_INDEX_PAGE = "/wallet/cash";
export const POINT_INDEX_PAGE = "/wallet/point";
export const RECEIPT_PAGE = "/receipt";
export const RECEIPT_CASH_PAGE = "/receipt/cash";
// Store Tab
export const MYPAGE_STORES_INDEX = "/mypage/stores" // 스토어
;
export const MYPAGE_STORES_PRODUCTS_INDEX = "/mypage/stores/products" // 스토어:상품 조회
;
export const MYPAGE_STORES_PRODUCTS_NEW_INDEX = "/mypage/stores/products/new" // 스토어:상품 등록
;
export const MYPAGE_STORES_PAYOUT_INDEX = "/mypage/stores/payouts" // 스토어:정산관리
;
export const MYPAGE_STORES_UCI_INDEX = "/mypage/stores/uci" // 스토어:uci 관리
;
// Viewer Page
export const VIEWER_PAGE = "/viewer";
export const VIEWER_PRINTOUT_PAGE = "/viewer/printout";
// Brand Page
export const BRAND_NOTICE_PAGE = (authorId)=>{
    return "/@".concat(authorId, "/notices");
};
export const BRAND_NOTICE_NEW_PAGE = (authorId)=>{
    return "/@".concat(authorId, "/notices/new");
};
export const BRAND_NOTICE_DETAIL_PAGE = (authorId, postId)=>{
    return "/@".concat(authorId, "/notices/").concat(postId);
};
export const BRAND_NOTICE_EDIT_PAGE = (authorId, postId)=>{
    return "/@".concat(authorId, "/notices/").concat(postId, "/edit");
};
export const BRAND_QNA_PAGE = (authorId)=>{
    return "/@".concat(authorId, "/qna");
};
export const BRAND_QNA_DETAIL_PAGE = (authorId, postId)=>{
    return "/@".concat(authorId, "/qna/").concat(postId);
};
export const BRAND_QNA_NEW_PAGE = (authorId)=>{
    return "/@".concat(authorId, "/qna/new");
};
export const BRAND_QNA_EDIT_PAGE = (authorId, postId)=>{
    return "/@".concat(authorId, "/qna/").concat(postId, "/edit");
};
export const BRAND_HOME_PAGE = (authorId)=>{
    return "/@".concat(authorId);
};
export const BRAND_ABOUT_PAGE = (authorId)=>{
    return "/@".concat(authorId, "/about");
};
export const BRAND_PRODUCTS_PAGE = (authorId)=>{
    return "/@".concat(authorId, "/products");
};
export const BRAND_SEARCH_PAGE = (authorId)=>{
    return "/@".concat(authorId, "/products/search");
};
export const BRAND_FULL_SEARCH_PAGE = (authorId)=>{
    return "/@".concat(authorId, "/products/full-search");
};
export const LAB_PRODUCTS_CATEGORY = "/products/category";
/**************** ADMIN CONSTANT (start) **************************/ // Admin Page
export const ADMIN_PAGE_LOGIN = "/admin/login";
/**************** ADMIN CONSTANT (end) **************************/ /**************** PUBLISHER CONSTANT (start) **************************/ export const PUBLISHER_LOGIN = "/publisher/login";
export const PUBLISHER_DASHBOARD = "/publisher/dashboard";
export const PUBLISHER_PRODUCT = "/publisher/product";
export const PUBLISHER_SALES_TEXTBOOK = "/publisher/sales/textbook";
export const PUBLISHER_SALES_HANDOUT = "/publisher/sales/handout";
export const PUBLISHER_PROTECT = "/publisher/protect";
/**************** PUBLISHER CONSTANT (end) **************************/ export const DEFAULT_BOOK_COVER = "/static/assets/img_book_def.jpg";
export const DEFAULT_CASH_COVER = "/static/assets/img_cash_def.svg";
/**************** PROMOTION CONSTANT (end) **************************/ export const PROMOTION_AUTHOR_PAGE = "https://promotion.solvook.com/promotions/consulting2/home";
export const PROMOTION_EBOOK_PAGE = "https://promotion.solvook.com/promotions/ebook";
/**************** HELP CENTER CONSTANT (end) **************************/ export const HELP_CENTER_PAGE = "https://help.solvook.com";
/**************** EXTERNAL LINK CONSTANT (end) **************************/ export const EXTERNAL_COMPANY_INTRODUCE = "https://solvookguide.oopy.io/company";
export const EXTERNAL_PROTECTION_REPORT_CENTER = "https://copyrightwatch.solvook.com";
export const EXTERNAL_PROTECTION_GUIDE = "https://solvookguide.oopy.io/copyright";
export const EXTERNAL_PROTECTION_TRAINING = "https://rightbookips.imweb.me/";
export const EXTERNAL_CHANNEL_TALK = "https://solvook.channel.io/home";
export const EXTERNAL_CHANNEL_TALK_POD = "https://solvook.channel.io/workflows/754580";
export const EXTERNAL_CAHNNEL_TALK_BOT = "https://solvook.channel.io/support-bots/92860";
export const EXTERNAL_SOLVOOK_GUIDE = "https://solvookguide.oopy.io/";
export const EXTERNAL_SOLVOOK_BLOG = "https://blog.naver.com/bookips";
export const SOLVOOK_STUDENT_BLOG_PAGE = "/blog";
export const EXTERNAL_B2B_WEBFLOW_PAGE = "http://biz.solvook.com";
export const EXTERNAL_PROMOTION_AUTHOR_PAGE = "https://promotion.solvook.com/apply/author";
export const EXTERNAL_CAREER_PAGE = "https://bookips.careers.team/";
export const EXTERNAL_INTRODUCE_LIBRARY = "https://solvookguide.oopy.io/guide/11";
export const EXTERNAL_SOLVOOK_MEMBERSHIP_PROMOTION = "https://promotion.solvook.com/promotions/membership";
export const EXTERNAL_DEVICE_GUIDE = "https://solvookguide.oopy.io/guide/device";
export const EXTERNAL_POD_GUIDE = "https://solvookguide.oopy.io/pod";
export const EXTERNAL_DELIVERY_GUIDE = "https://solvookguide.oopy.io/delivery";
export const POD_PAYMENT_PAGE = "/pod/payment";
export const POD_PAGE = "/pod";
export const EXTERNAL_POD_COVER_GUIDE = "https://solvookguide.oopy.io/pod-cover";
export const BOOKS_LANDING = "/books";
export const BOOKS_ORDER = "/books/order";
export const BOOKS_PRODUCT = "/books/products";
export const BOOKS_DELIVERY_ADDRESS = "/books/delivery-address";
export const EBOOKS_LANDING = "/ebooks";
export const EBOOKS_ORDER = "/ebooks/order";
export const EBOOKS_PRODUCT = "/ebooks/products";
export const EBOOKS_UNIVERSITY_LANDING = "/goodnotes-univ" //대학생용 ebook 메인 페이지
;
export const EBOOKS_UNIVERSITY_PRODUCT = "/goodnotes-univ/products";
export const EBOOKS_UNIVERSITY_ORDER = "/goodnotes-univ/order";
export const PASSES_LANDING = "/passes" //이용권 페이지
;
export const PASSES_NEW = "/passes/new" //이용권 등록
;
export const MYPAGE_PASSES = "/mypage/passes" //이용권 관리
;
export const MYPAGE_SUBSCRIPTION = "/mypage/subscription" //구독 관리
;
export const MYPAGE_SUBSCRIPTION_CANCEL = (membershipId)=>"".concat(MYPAGE_SUBSCRIPTION, "/").concat(membershipId, "/cancel") //구독 해지 신청
;
export const PASSES_TEACHER = "/passes/teacher";
export const PASSES_STUDENT = "/passes/student";
export const PASSES_UPGRADE = "/passes/upgrade";
// ⚠️ 레거시 — 참조 0건. 6a67cab7 에서 PassItem 의 진입 링크가 제거돼 도달 불가.
// /subscribe 페이지 정리 시 함께 제거한다.
export const SUBSCRIBE_PAYMENTS = "/subscribe" //정기결제 신청
;
export const PROMOTION_MEGASTUDY = "promotion/megastudy";
export const SOLVOOK_WRITE_STUDIO = process.env.NEXT_PUBLIC_STUDIO_URL + "/handouts" //저작스튜디오
;
export const SOLVOOK_EDIT_STUDIO = process.env.NEXT_PUBLIC_EDIT_STUDIO_URL + "/layout" //편집스튜디오
;
export const EXPERT_PRE_EXAM = process.env.NEXT_PUBLIC_EDIT_STUDIO_URL + "/handouts/pre-exam" //엑스퍼트 우리학교 기출 경로
;
//엑스퍼트 변형문제 생성 페이지 (교재 기준)
export const getExpertVariantQuestionUrl = (subject, sourceId)=>"".concat(process.env.NEXT_PUBLIC_STUDIO_URL, "/handouts/").concat(subject, "/variant-question/new/config/").concat(sourceId);
export const REVIEWS_NEW = "/reviews/new";
export const COUPONS_LANDING = "/coupons";
export const MYPAGE_COUPONS = "/mypage/coupons" //쿠폰 관리
;
export const STUDIO_TITLE = "학습지 편집";
export const EXTERNAL_PACKAGE_CAMPAIGN = "https://solvookguide.oopy.io/package";
export const SOLVOOKPASS_TEXT = "쏠북패스";
// main 과목 외, 광고 경로 ex. 쏠북패스, 브랜드관
export const EDITION_CATEGORY_PAGE = "/categories/edition";
export const EDITION_CATEGORY_DAECHI = "/categories/edition/daechi";
export const EDITION_CATEGORY_BRAND = "/categories/edition/brand";
export const EDITION_CATEGORY_EN = "/categories/edition/brand-en";
export const EDITION_CATEGORY_KO = "/categories/edition/brand-ko";
export const EDITION_CATEGORY_MA = "/categories/edition/brand-ma";
export const EDITION_CATEGORY_SC = "/categories/edition/brand-sc";
export const EDITION_CATEGORY_SO = "/categories/edition/brand-so";
export const EXTERNAL_PARTNER_CENTER = process.env.NEXT_PUBLIC_PARTNER_URL;
export const EXTERNAL_WALLET_GUIDE = "https://solvookguide.oopy.io/cashpoint";
// 쏠북앱 웹뷰 페이지
export const SOLVOOK_APP_PAGE = "/solvook-app";
export const SOLVOOK_APP_MARKET_PAGE = "/solvook-app/market";
export const SOLVOOK_APP_MARKET_SUBJECT_PAGE = (categoryId)=>"/solvook-app/market/".concat(categoryId);
export const SOLVOOK_APP_MARKET_EDITION_PAGE = (editionId)=>"/solvook-app/market/edition/".concat(editionId);
export const SOLVOOK_APP_SCHOOL_EXAM_PAGE = "/solvook-app/school-exam";
export const SOLVOOK_APP_SCHOOL_EXAM_SUBJECT_PAGE = (subjectKey)=>"/solvook-app/school-exam/".concat(subjectKey);
export const SOLVOOK_APP_SCHOOL_EXAM_SCHOOL_PAGE = (schoolId)=>"/solvook-app/school-exam/school/".concat(schoolId);
export const SOLVOOK_APP_SAMPLE_PAGE = (productId)=>"/solvook-app/sample/".concat(productId);
